import React from 'react';

import { Icon } from '../stories/Icon';

interface CarouselNextArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const CarouselNextArrow = (props: CarouselNextArrowProps) => {
  const { className, style, onClick } = props;
  return <Icon name="chevron-right" onClick={onClick} style={style} className={className} />;
};
